import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import Styles from './FlaggedFund.css'
// import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import ReactTooltip from 'react-tooltip'
import moment from 'moment'

@CSSModules(Styles)
export default class FlaggedFund extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    weight: PropTypes.number.isRequired,
    portfolioDate: PropTypes.string,
    totalFunds: PropTypes.number,
    isFamily: PropTypes.bool
  }
  constructor(props){
    super(props)
  }

  render() {
    function renderStatCount(tip, count, label){
      return (
        <div
          styleName={'stat'}
          data-multiline={true}
          data-effect={'solid'}
          data-tip={tip}
          data-for='flaggedfund-tooltip'>
          <div styleName='stat-count-wrapper'>
            <div styleName='stat-count'>{count}</div>
          </div>
          <div styleName='stat-label'>{label}</div>
        </div>)
    }

    const type = (this.props.isFamily) ? 'family' : 'fund'

    return (
      <div styleName='stats-wrapper'>
        <div styleName='stats'>

          { (this.props.isFamily)?
            renderStatCount('Number of funds analyzed from this '+type,
              format.number(this.props.totalFunds), 'funds analyzed' ) : null }

          {renderStatCount('Total number of fossil fuel<br/> stock holdings found in this '+type,
            format.number(this.props.count), 'fossil fuel stocks found' )}

          {renderStatCount('Total percent of the '+type+'\'s long-position assets<br/>invested in fossil fuel stocks',
            format.perc(this.props.weight), 'of assets flagged' )}

        </div>

        { (!this.props.isFamily)?(
        <div>
          <div styleName='view-more-data'>
            Portfolio data as of {moment(this.props.portfolioDate).format('M/DD/YY')}
          </div>
        </div>
        ):null}

        <ReactTooltip id='flaggedfund-tooltip'/>

      </div>
    )
  }
}

